// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (id) {
    return function (org) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const match$2 = React.useState(function () {
            return false;
          });
      const setWithdrawCash = match$2[1];
      const withdrawCash = match$2[0];
      const func = Buhta_cabinet__Kassa.KkmManagerService.getRunningBalance;
      const match$3 = Buhta_core__GrpcState.useModel((function (param) {
              return Curry._3(func, param, /* [] */0, id);
            }), undefined);
      const dispatch = match$3[1];
      const balance = match$3[0];
      React.useEffect((function () {
              Curry._2(dispatch, undefined, undefined);
            }), [id]);
      const availableCash = typeof balance === "string" || balance.NAME !== "Data" ? "0" : balance.VAL.available_cash;
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: "Закрытие смены"
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-6 h-6",
                                              src: StaticAsset.src("/static/icons/close.svg")
                                            }),
                                        onClick: (function (param) {
                                            Curry._1(onClose, undefined);
                                          })
                                      })
                                ],
                                className: "px-6 py-4 flex justify-between"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-6 h-6",
                                        src: StaticAsset.src("/static/icons/cash-gray.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                        className: "ml-4",
                                        children: "Наличные в кассе: "
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        className: "ml-1",
                                        children: MelNumeral.format({
                                              NAME: "Str",
                                              VAL: availableCash
                                            }) + " ₸"
                                      })
                                ],
                                className: "p-6 flex"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                        isChecked: withdrawCash,
                                        onChange: (function (param) {
                                            Curry._1(setWithdrawCash, (function (param) {
                                                    return !withdrawCash;
                                                  }));
                                          }),
                                        text: "Снять наличные с кассы"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                        title: "Закрыть смену",
                                        onClick: (function (param) {
                                            const form = {
                                              withdraw_cash: withdrawCash
                                            };
                                            const contextRoute = function (route) {
                                              return Buhta_cabinet__Route.contextRoute(tenant.ctx, org, route);
                                            };
                                            const __x = Buhta_cabinet__Kassa.ZxReportService.closeShift(tenant, id, form);
                                            $$Promise.get(__x, (function (result) {
                                                    if (result.TAG !== /* Ok */0) {
                                                      return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при закрытии смены");
                                                    }
                                                    window.open(Buhta_cabinet__Route.toString(contextRoute({
                                                                  TAG: /* Kassa */2,
                                                                  _0: /* Kkms */{
                                                                    _0: /* Kkm */{
                                                                      _0: id,
                                                                      _1: {
                                                                        TAG: /* Journal */2,
                                                                        _0: /* Shifts */{
                                                                          _0: {
                                                                            TAG: /* View */0,
                                                                            _0: result._0.id
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                })), "_blank", undefined);
                                                    Curry._1(onClose, undefined);
                                                    Curry._1(dispatchToasts, {
                                                          TAG: /* Add */0,
                                                          _0: {
                                                            id: Buhta_core__Toast.generateId(undefined),
                                                            text: "Смена закрыта",
                                                            kind: "success",
                                                            onClick: (function (param) {
                                                                
                                                              })
                                                          }
                                                        });
                                                  }));
                                          }),
                                        className: "w-full mt-4 py-3"
                                      })
                                ],
                                className: "px-6 py-4"
                              })
                        ],
                        className: "w-106 bg-white rounded shadow-payroll"
                      }),
                  className: "absolute inset-0 bg-black/40 flex justify-center items-center"
                });
    };
  };
}

function KkmCloseShiftModal(Props) {
  return Curry._1(make(Props.onClose)(Props.id), Props.org);
}

const make$1 = KkmCloseShiftModal;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
